module.exports = global["$"] = require("-!C:\\Users\\Frontend\\Downloads\\OSPanel\\domains\\sbctech\\node_modules\\expose-loader\\index.js?jQuery!C:\\Users\\Frontend\\Downloads\\OSPanel\\domains\\sbctech\\node_modules\\source-map-loader\\index.js!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 55
// module chunks = 0 1 8 20